module.exports = __webpack_public_path__ + "static/media/icon-money-4.80b2d07f.svg";